<style scoped> 
    .info-box {
        height: 100px; /* Fija la altura */
        overflow: auto; /* Permite el scroll si el contenido excede la altura */
        white-space: pre-line;
        padding: 15px; /* Espacio interno más generoso */
        border: 1px solid #ddd; /* Borde más sutil */
        border-radius: 8px; /* Bordes redondeados */
        font-size: 14px; /* Tamaño de fuente */
        line-height: 1.6; /* Mayor espaciado entre líneas para mejorar la legibilidad */
        background-color: #f4f6f9; /* Color de fondo más suave */
        width: 100%; /* Ajusta el ancho */
        box-sizing: border-box; /* Padding no afecta el tamaño total */
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Sombra suave para darle profundidad */
        color: #333; /* Color del texto */
    }

    .info-box:focus {
        outline: none; /* Quita el borde predeterminado del input al enfocarse */
        border-color: #a0d1fb; /* Color de borde más vibrante al enfocarse */
        box-shadow: 0 0 6px rgba(32, 150, 243, 0.5); /* Sombra más vibrante al enfocarse */
    }
</style>
<template>
    <div class="form-group mb-4">
		<div class="info-box"> {{ selected }}</div>
	</div>
</template>
  
<script>
    export default {
        name: 'DescriptionAddress',
        props: {
            value: {
                type: [String, Number, Object, Array],
                default: null
            },
        },
        computed: {
            selected: {
                get() {
                    if (Array.isArray(this.value)) {
                        return this.value.join('\n');
                    }else{
                        return this.value;
                    }
                },
                set(newValue) {
                    if (Array.isArray(newValue)) {
                        return newValue.join('\n');
                    }else{
                        this.$emit('input', newValue);
                    }
                }
            }
        }
    }
</script>